/* eslint-disable formatjs/enforce-placeholders */
import useLandingContents from "components/landing/hooks/useLandingContents";
import classNames from "components/ui/classNames";
import Twemoji from "components/ui/Twemoji";
import { isWithinInterval } from "date-fns";
import getBaseUrl from "lib/utils/getBaseUrl";
import Link from "next/link";
import CountUp from "react-countup";
import { FormattedMessage, useIntl } from "react-intl";
import { format } from "util";

export default function PlatformMetricsSection() {
  const intl = useIntl();
  const { platformMetrics, isUsLanguage } = useLandingContents();

  const isBlackNovemberPeriod = isWithinInterval(new Date(), {
    start: new Date("2025-11-01T03:00:00Z"),
    end: new Date("2025-12-01T23:59:59Z"),
  });

  return (
    <section className="mx-auto flex max-w-7xl flex-col items-center px-6 pb-16 lg:px-0">
      {false && (
        <Link
          href="/screener"
          className={classNames(
            "relative mb-12 flex gap-x-2 text-pretty rounded-full bg-viridian-50 px-2 py-1 text-sm/6 text-slate-600 sm:px-3",
            "ring-1 ring-viridian-400/30 hover:opacity-80 hover:ring-viridian-600/30",
            "text-center font-medium",
          )}
        >
          <p className="[&>strong]:text-brand">
            <span className="font-bold uppercase text-viridian-600" aria-hidden={true}>
              <FormattedMessage defaultMessage="Novidade" id="yC7RnY" />
            </span>
            <span> — </span>
            <FormattedMessage
              defaultMessage="Clique e confira o nosso mais recente lançamento: <b>o Screener</b>"
              id="vSG9Ve"
            />
          </p>
        </Link>
      )}

      {isBlackNovemberPeriod && (
        <Link
          href="#pricing"
          className={classNames(
            "relative mb-12 flex gap-x-2 text-pretty rounded-full bg-slate-800 px-4 py-3 text-sm tracking-wide text-white",
            "hover:opacity-80",
            "text-center font-medium",
          )}
        >
          <p>
            <span className="font-bold uppercase text-lime-300 brightness-100" aria-hidden={true}>
              <FormattedMessage defaultMessage="Black November" id="EWr7SI" />
            </span>
            <span> — </span>
            <strong className="text-red-300 brightness-125">45% OFF no Plano Anual.</strong> Aproveite já por tempo
            limitado! <Twemoji emoji="🔥" />
          </p>
        </Link>
      )}

      <header className="mx-auto flex max-w-3xl flex-col gap-4">
        <h1 className="text-center text-3xl font-black lg:text-5xl">
          <FormattedMessage defaultMessage="Análise de Ações, Fundos Imobiliários, Stocks e REITs" id="rqcjGp" />
        </h1>

        <p className="text-center text-lg text-zinc-600">
          <FormattedMessage
            defaultMessage="O melhor site de Buy&Hold do Brasil com acesso imediato a mais de 6.000 ativos!"
            id="NMfQgR"
          />
        </p>
      </header>

      <div className="overflow-hidden rounded-xl p-4 py-12 lg:h-[628px] lg:py-4">
        <video
          muted={true}
          autoPlay={true}
          loop={true}
          playsInline={true}
          className={classNames(
            "pointer-events-none w-full max-w-6xl overflow-hidden rounded-3xl bg-transparent object-cover",
            "scale-125 md:scale-100 lg:h-[628px]",
          )}
        >
          <source
            type="video/mp4"
            src={format(
              "%s/static/landing/video/%s/fundamentals.mp4",
              getBaseUrl(),
              intl.locale === "pt-BR" ? "pt" : "en",
            )}
          />
        </video>
      </div>

      <div className="grid items-center gap-12 lg:grid-cols-4 lg:gap-0 lg:divide-x lg:divide-slate-100">
        {(isUsLanguage ? platformMetrics.US : platformMetrics.BR).map(({ indicator, value, ...rest }) => (
          <div key={indicator} className="flex flex-col gap-2 px-5 text-center lg:mt-4">
            <h4 className="text-2xl font-bold lg:text-4xl">
              <CountUp end={value} duration={2.75} enableScrollSpy={false} {...rest} />
            </h4>

            <p className="text-sm text-zinc-500">{indicator}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
